<template>
    <pp-modal v-model="showModal" :mask-closable="false" width="450" :closable="false">
        <div class="modalhead">
            <div class="">流水详情</div>
            <div class="secondTitle">流水号：{{params.id}}</div>
        </div>
        <div class="content">
            <div class="line">
                <div class="fl">业务类型</div>
                <div class="fr">{{this.$filters.getFondTypeName(params.fundType)}}</div>
            </div>
            <div class="line" v-if="(this.$filters.getFondTypeName(params.fundType)) == '退款' || (this.$filters.getFondTypeName(params.fundType)) == '保证金退款返还'">
                <div class="fl">退款时间</div>
                <div class="fr">{{this.$filters.timestampToDatetime(params.operateTime)}}</div>
            </div>
            <div class="line">
                <div class="fl">交易流水号</div>
                <div class="fr">{{params.transactionId}}</div>
            </div>
            <div v-if="(this.$filters.getFondTypeName(params.fundType)) == '退款' || (this.$filters.getFondTypeName(params.fundType)) == '保证金退款返还'" class="line">
                <div class="fl">退款金额</div>
                <div class="fr">{{params.currency}} {{params.amount}}</div>
            </div>
            <div v-if="params.fundType=='INBOUND'" class="line">
                <div class="fl">入账金额</div>
                <div class="fr color-999">{{params.currency}} {{params.amount}}</div>
            </div>
            <div class="line" v-if="params.diffentTradeCurrency">
                <div class="fl">我们会以（原币种）给用户进行退款，以上金额数据为参考数据，实际退款金额以退款完成状态为准。</div>
            </div>
            <div class="line" v-if="params.fundType=='INBOUND'">
                <div class="fl">入账时间</div>
                <div class="fr">{{this.$filters.timestampToDatetime(params.operateTime)}}</div>
            </div>
        </div>
        <div slot="footer" class="textright">
            <pp-button class="modal-btn" type="primary" size="spec" @click="sure">确认</pp-button>
        </div>
    </pp-modal>
</template>

<script>
    import {
        createNamespacedHelpers
    } from 'vuex'
    import {
        Getter,
        Action,
        namespace
    } from 'vuex-class'
    const {
        mapGetters: webMapGetters,
        mapActions: webMapActions
    } = createNamespacedHelpers('website')
    
    export default {
        name: 'tradeFlowDetailModal',
        props: {},
        mounted() {},
        data() {
            return {
                showModal: false,
                params: {}
            }
        },
        methods: {
            sure() {
                this.showModal = false
            },
            show(params) {
                this.params = params,
                this.showModal = true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modalhead {
        display: block;
        width: 100%;
        height: 60px;
        line-height: 30px;
        font-size: 20px;
        color: #1c2438;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }
    
    .textright .modal-btn {
        padding: 6px 20px;
        height: 32px;
        text-align: center;
        font-size: 14px;
    }
    
    .secondTitle {
        color: #000;
        font-size: 14px;
        height: 18px;
        line-height: 18px;
        text-align: left;
        filter: alpha(opacity=56);
        -moz-opacity: 0.56;
        -khtml-opacity: 0.56;
        opacity: 0.56;
        margin-bottom: 4px;
    }
    
    .modalContent {
        text-align: left;
        font-size: 14px;
    }
    
    .content {
        width: 100%;
        .line {
            height: 20px;
            font-size: 14px;
            line-height: 20px;
            margin-top: 16px;
        }
        .bankline {
            margin-top: 16px;
            height: 70px;
            img {
                float: left;
                display: block;
                width: 64px;
                height: 64px;
            }
            .info {
                height: 64px;
                float: left;
                margin: 0 0 0 41px;
                div {
                    height: 32px;
                    line-height: 32px;
                }
            }
        }
    }
</style>
